var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBook1 = function SvgBook1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#22253B",
    d: "M21.717 18.24 18.606 3.444a1.5 1.5 0 0 0-1.782-1.161l-4.388.943a1.51 1.51 0 0 0-1.153 1.781l3.111 14.794a1.5 1.5 0 0 0 1.782 1.164l4.388-.943a1.51 1.51 0 0 0 1.153-1.784M12.75 4.701v-.009l4.387-.937.313 1.487-4.388.945zm.938 4.441-.315-1.49 4.39-.943.313 1.49zm6.562 9.414-4.387.937-.313-1.487 4.388-.944.312 1.486zM9.75 3h-4.5a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5h4.5a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 9.75 3m-4.5 1.5h4.5V6h-4.5zm4.5 15h-4.5V18h4.5z"
  })));
};
export default SvgBook1;